/** @jsx jsx */
import { jsx } from "theme-ui"
import Svg from "./base"

const Icon = props => (
  <Svg width="100" height="100" {...props}>
    <path
      fill="#B92A2E"
      d="M63.119 62.08c0-9.05-6.663-15.092-16.016-17.345l-8.662 7.599-8.908-7.823c-9.223 1.758-15.77 6.82-15.77 17.557v5.84H8v2.856h9.235v5.073h-1.753c-.585 0-1.123.284-1.462.767a1.787 1.787 0 00-.21 1.64l2.595 7.21c.257.708.924 1.18 1.672 1.18h40.717a1.78 1.78 0 001.671-1.18l2.596-7.21a1.812 1.812 0 00-.21-1.64 1.775 1.775 0 00-1.462-.767h-1.742v-5.073h9.235v-2.856H63.12V62.08zm-6.137 21.78H19.9V60.747c0-.79.643-1.427 1.426-1.427h34.252c.783 0 1.414.637 1.414 1.427v23.115h-.011zm-4.5-57.037c.05-7.827-6.194-14.212-13.948-14.263-7.754-.051-14.08 6.252-14.131 14.079-.05 7.826 6.194 14.212 13.948 14.262 7.754.051 14.081-6.252 14.131-14.078z"
    ></path>
    <path
      fill="#B92A2E"
      d="M38.441 68.781c-1.788 0-3.238 1.464-3.238 3.269 0 1.805 1.45 3.268 3.238 3.268 1.789 0 3.238-1.463 3.238-3.268 0-1.805-1.45-3.269-3.238-3.269zm36.052-51.208c-9.107 0-16.518 7.48-16.518 16.672s7.4 16.66 16.518 16.66c9.106 0 16.506-7.48 16.506-16.672 0-9.191-7.4-16.66-16.506-16.66zm0 30.383c-7.494 0-13.596-6.16-13.596-13.723 0-7.563 6.102-13.722 13.596-13.722 7.493 0 13.584 6.16 13.584 13.723 0 7.575-6.09 13.722-13.584 13.722z"
    ></path>
    <path
      fill="#B92A2E"
      d="M75.943 33.55v-6.125c0-.814-.655-1.474-1.461-1.474-.807 0-1.462.66-1.462 1.474v6.808c0 .437.188.85.515 1.133l6.032 5.145c.28.236.608.354.947.354.42 0 .83-.177 1.122-.52a1.474 1.474 0 00-.175-2.076l-5.518-4.72z"
    ></path>
  </Svg>
)

export default Icon
